// extracted by mini-css-extract-plugin
module.exports = {"navigationContainer":"styles_navigationContainer__eMK6F","dotReplacement":"styles_dotReplacement__1M4yQ"};